export default __webpack_public_path__ + "static/media/battery-1.fde95fa3.png";